const togglers = Array.from(document.querySelectorAll('.js-accordian'));

function toggleAccordian(element) {
    element.classList.toggle('is-active');
    element.parentNode.classList.toggle('is-active');

    const list = element.nextElementSibling;
    if (list.style.maxHeight) {
        list.style.maxHeight = null;
    } else {
        list.style.maxHeight = `${list.scrollHeight}px`;
    }
}

togglers.forEach((element) => {
    element.addEventListener('click', () => {
        if ('collapseOthers' in element.dataset && !element.classList.contains('is-active')) {
            Array.from(document.querySelectorAll('.js-accordian.is-active')).forEach((el) => {
                toggleAccordian(el);
            });
        }

        toggleAccordian(element);
    });
});



// WEBPACK FOOTER //
// ./app/scripts/components/accordian.js